// === Share a task (Web Share API with clipboard fallback) ===

const APP_URL = 'https://www.ahihealthyanimal.ie/';

// Builds the full message a farmer would send to their vet / colleague:
// title, summary, why-it-matters, key action tips, then a link to the tool.
function buildShareMessage(item) {
  const c = item.content || {};
  const title = c.title || 'Herd health task';
  const parts = [title];

  if (c.summary) parts.push('', c.summary);
  if (c.notes) parts.push('', `Why it matters: ${c.notes}`);

  const tasks = (item.tasks || []).map(t => `• ${t.label}`);
  if (tasks.length) parts.push('', 'Key actions:', ...tasks);

  parts.push('', `Check it out yourself in the Herd Health Calendar: ${APP_URL}`);

  return { title, body: parts.join('\n') };
}

// Returns a short status string for optional UI feedback: 'shared',
// 'copied', 'mailto', or 'cancelled'.
export async function shareItem(item) {
  const { title, body } = buildShareMessage(item);

  if (navigator.share) {
    try {
      // Pass the full content as `text`; omit `url` so it isn't appended
      // twice (the link is already the closing line of the message).
      await navigator.share({ title, text: body });
      return 'shared';
    } catch (e) {
      // User cancelled the share sheet — not an error worth surfacing.
      return 'cancelled';
    }
  }

  // Fallback: copy to clipboard.
  try {
    await navigator.clipboard.writeText(body);
    return 'copied';
  } catch (e) {
    // Last resort: open a mailto.
    const subject = encodeURIComponent(title);
    const mailBody = encodeURIComponent(body);
    window.open(`mailto:?subject=${subject}&body=${mailBody}`, '_blank');
    return 'mailto';
  }
}
